import { StrategyDescription } from '#/components/UnifiedRfqs/components/strategy-description/StrategyDescription';
import { Order } from '@paradigm/features/src/unified-rfqs/entities/drfq/orders';
import Text from '@paradigm/design-system/src/components/Text/Text';
import {
  RfqProvider,
  useRfqContext,
} from '@paradigm/features/src/unified-rfqs/ui/rfq-context';
import { lima, razzmatazz } from '@paradigm/design-system/src/colors';

interface Props {
  order: Order;
}

export default function ToastRfqOrderCanceled({ order }: Props) {
  return (
    <RfqProvider rfqId={order.rfq_id}>
      <ToastContent order={order} />
    </RfqProvider>
  );
}

function ToastContent({ order }: Props) {
  const { rfq } = useRfqContext();
  const { side, price, quantity } = order;

  const orderType = order.type === 'LIMIT' ? 'FOK' : 'Hidden Limit';

  return (
    <Text weight="light">
      {orderType} Order{' '}
      <Text color={side === 'BUY' ? lima : razzmatazz}>{side}</Text> {price}{' '}
      {quantity}x was <Text weight="bold">CANCELED</Text>{' '}
      {rfq != null && (
        <Text>
          for <StrategyDescription>{rfq.description}</StrategyDescription>
        </Text>
      )}
    </Text>
  );
}
